document.addEventListener("DOMContentLoaded", () => {
  const menuItems = document.querySelectorAll(".header__inline-menu details");

  $("#Details-HeaderMenu-1").on('click',()=>{
     window.location.href = '/'
  })  
  
  $("#HeaderMenu-galleries").on('click',()=>{
     window.location.href = '/pages/galleries'
  })
  
  menuItems.forEach((item) => {
    const submenu = item.querySelector("ul");

    // Open the dropdown on hover
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
    });

    // Close the dropdown when the mouse leaves
    item.addEventListener("mouseleave", () => {
      setTimeout(() => {
        if (!item.matches(":hover") && !submenu.matches(":hover")) {
          item.removeAttribute("open");
        }
      }, 200); // Add a small delay to prevent accidental closing
    });

    // Ensure submenu stays open when hovering over it
    if (submenu) {
      submenu.addEventListener("mouseleave", () => {
        if (!item.matches(":hover")) {
          item.removeAttribute("open");
        }
      });
    }
  });
});

window.onscroll = function() {
    const scroll_button = document.getElementById("scrollToTopBtn");
    if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
        scroll_button.classList.add("show");
    } else {
        scroll_button.classList.remove("show");
    }
}; 

function scrollToTop() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth' // Smooth scroll effect
    });
}  